/* eslint-disable no-console */
import React, { useEffect } from 'react';
import { Col } from 'reactstrap';
import InputComponent from '../InputComponent';

const Checkbox = (props) => {
    const onCheckBoxChanged = (e) => {
        props.changed(e.target);
    };

    return (
        <React.Fragment>
            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="pe-0 mt-0">
                <div
                    className={`form-check custom-form-selection d-flex align-items-center ${
                        props.value?.indexOf(props?.answerInternalIdentifier) !== -1 ? 'custom-form-selection-active' : ''
                    }`}
                >
                    <InputComponent
                        className={`${props?.displayPosition === 'right' ? 'form-check-left' : ''} form-check-input`}
                        type="checkbox"
                        name={props?.answerInternalIdentifier}
                        id={props?.answerInternalIdentifier}
                        checked={props.value?.indexOf(props?.answerInternalIdentifier) !== -1}
                        value={props?.answerInternalIdentifier}
                        onChange={(e) => {
                            onCheckBoxChanged(e);
                            props?.handleDownloadFile &&
                                props.downloadLink &&
                                e.target.checked &&
                                props.handleDownloadFile(props.downloadLink);
                        }}
                        disabled={props.disable}
                        // onBlur={props.handleOnBlur}
                    />
                    <label
                        className={`${
                            props?.displayPosition === 'right' ? 'form-check-left-label' : 'ms-2'
                        } form-check-label  d-flex align-items-center ${
                            props.value?.indexOf(props?.answerInternalIdentifier) !== -1 ? 'label-active' : ''
                        }`}
                        htmlFor={props?.answerInternalIdentifier}
                    >
                        {props.answerText}
                    </label>
                </div>
            </Col>
        </React.Fragment>
    );
};

export default Checkbox;
